import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '@environment/environment';

/**
 * Guard that redirects to "Coming Soon" page when the feature is enabled.
 * This is used to block access to the application before official launch.
 */
@Injectable({
  providedIn: 'root'
})
export class ComingSoonGuard implements CanActivate {
  
  constructor(private router: Router) {}
  
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // If coming soon mode is enabled, redirect to coming-soon page
    if (environment.comingSoon) {
      return this.router.createUrlTree(['/coming-soon']);
    }
    
    // Otherwise, allow access
    return true;
  }
}
